import { JsonLd } from './JsonLd';

export interface FAQItem {
  q: string;
  a: string;
}

/**
 * Real ASWB questions with honest, compliant answers. The pass gap is cited as
 * the ASWB's OWN published data; there are no pass guarantees; Pam REVIEWS the
 * questions (never "wrote"/"authored").
 */
const FAQ_ITEMS: ReadonlyArray<FAQItem> = [
  {
    q: "What's the ASWB pass rate gap?",
    a: "According to the ASWB's own published pass-rate data, first-time pass rates vary widely across groups. For example, Black first-time test-takers have historically passed the clinical exam at rates roughly 35–45 percentage points lower than white first-time test-takers. Social Work Test Prep Academy was built to help close that gap with adaptive, targeted practice.",
  },
  {
    q: 'How much does SWTPA cost?',
    a: 'Full access is a one-time purchase of $129. There is no subscription and no recurring charge. You keep access and can study until you pass.',
  },
  {
    q: "Do I need to re-buy if I don't pass?",
    a: "No. The $129 is a one-time purchase that stays with you until you pass your exam. If you need more time, you won't be charged again.",
  },
  {
    q: "Who reviews SWTPA's practice questions?",
    a: 'The practice questions are reviewed by Pamela Coin, a Licensed Clinical Social Worker (LCSW) and Board Approved Clinical Supervisor.',
  },
];

/**
 * Build FAQPage schema for ANY set of questions (defaults to the pricing FAQ).
 *
 * Blog posts pass their own: an FAQ block is the single cheapest thing that gets
 * a page quoted by an AI assistant, because each Q/A is already the shape an
 * answer engine wants to lift. That matters here more than usual — 90 days of
 * Search Console shows every blog post at ZERO impressions, so classic ranking
 * is not the channel; being citable is.
 */
export function buildFAQPageSchema(items: ReadonlyArray<FAQItem> = FAQ_ITEMS) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: a,
      },
    })),
  };
}

export function FAQPageSchema({ items }: { items?: ReadonlyArray<FAQItem> }) {
  return <JsonLd data={buildFAQPageSchema(items)} />;
}
